export enum ResearchResultsVisibility {
  AfterSurvey = 0,
  AlwaysHidden = 1,
  AlwaysVisible = 2,
}
